export default __webpack_public_path__ + "static/media/cx_cover_tln1sc.6b852c8d.jpg";